import { AnnotationPlugin } from '@st/document-viewer-kit'
import { CalculatorTapeAnnotation } from '@st/sdk'
import { CalculatorTapeToolState } from '~/st-doc-viewer/annotations'
import { CalculatorTapeAnnotationElement, CalculatorTapeToolOverlay } from './ui'

export function calculatorTapePlugin(): AnnotationPlugin<
  CalculatorTapeAnnotation,
  CalculatorTapeToolState
> {
  return {
    name: 'calculator_tape',
    initialToolState: {
      name: 'calculator_tape'
    },
    ToolOverlay: CalculatorTapeToolOverlay,
    Element: CalculatorTapeAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type === 'calculator_tape',
    onAnnotationDeselected: (event, send) => {
      // if someone clicked down and didn't do anything (didn't add line items)
      // we should the draft for an empty tape
      if (event.annotationDraft && event.annotationDraft.lineItems.length == 0) {
        send({ type: 'discardAnnotationDraft', annotationId: event.annotationDraft.id })
      } else if (event.annotationDraft && !event.annotation) {
        send({ type: 'createAnnotation', annotationDraft: event.annotationDraft })
      } else if (event.annotationDraft && event.annotation) {
        send({ type: 'updateAnnotation', annotationDraft: event.annotationDraft })
      }
    }
  }
}
